import { usePageOverlay } from './pageOverlayHandler/usePageOverlayHandler';
import RateModal from '@components/util/RateModal.vue';

export const useRatingModal = () => {
    const pageOverlayHandler = usePageOverlay();
    const { isAndroid } = useDevice();
    onMounted(async () => {
        const { lastPaymentStatus, lastRatingDate } = getRateModalStorage();

        if (
            lastPaymentStatus === 'success' &&
            lastRatingDate.add(3, 'month').isSameOrBefore(dayConfig.js()) &&
            isAndroid.value
        ) {
            const result = await pageOverlayHandler.addAsyncLayer({
                component: RateModal,
                props: {},
            });
            if (result) {
                setRateModalStorage({
                    lastRatingDate: dayConfig.js().toDate(),
                });
                window.open('https://cafebazaar.ir/app/com.mrbilit.app');
            } else {
                setRateModalStorage({ lastPaymentStatus: 'none' });
            }
        }
    });
};
